export default __webpack_public_path__ + "static/media/mule-deer.29161d2b.png";